export default "__VITE_ASSET__CuRJPejK__"